module.exports = __webpack_public_path__ + "02_veryshort_brown.24ed23ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_veryshort_brown.png
// module id = 5PRr
// module chunks = 0